import React, { Component } from 'react';
import { Alert, Label, FormGroup, Input, Row, Col, Button } from 'reactstrap';

export default class Dropdowns extends Component {
    constructor(props) {
        super(props);

        this.state = { codeFields: [], values: [], selectedField: '', addNewDisabled: true, newValue: ''}
    }

    componentDidMount() {
        fetch('/api/Codes/GetCodeFields', {
            method: 'GET'
        })
        .then(response => response.json())
        .then(data => {
            let fields = [];
            for(let key in data) {
                fields.push(data[key]);
            }

            this.setState({codeFields: fields});
        })
    }

    onFieldPickerChange = (e) => {
        if(e.target.value) {
            fetch('api/Codes/type/' + e.target.value, {
                method: 'GET'
            })
            .then(response => response.json())
            .then(data => {
                let values = {};
                for(let item in data) {
                    data[item].didChange = false;
                    values[data[item].id] = data[item];
                }
                this.setState({ values: data });
            })
        }

        this.setState({ selectedField: e.target.value })
    }

    onValueChange = (e) => {
        let values = this.state.values;
        values[e.target.name].description = e.target.value;
        values[e.target.name].didChange = true;
        this.setState({ values: values });
    }

    onCheckedChange = (e) => {
        let values = this.state.values;
        values[e.target.name].isActive = e.target.checked;
        values[e.target.name].didChange = true;
        this.setState({values: values});
    }

    handleSave = (e) => {
        let name = e.target.name;
        let code = this.state.values[name];
        fetch('/api/Codes/' + code.id, {
            method: 'PUT',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(code)
        })
        .then(response => {
            if(response.ok) {
                let values = this.state.values
                values[name].didChange = false;
                this.setState({values: values})
            }
        })
    }

    newValueChange = (e) => {
        this.setState({newValue: e.target.value})
        if(e.target.value) {
            this.setState({addNewDisabled: false})
        } else {
            this.setState({addNewDisabled: true})
        }
    }

    addNewValue = () => {
        fetch('/api/Codes', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify( {
                description: this.state.newValue.trim(),
                type: this.state.selectedField,
                isActive: true,
                didChange: false
            })
            
        })
        .then(response => response.json())
        .then(data => {
            this.setState((prevState) => ({
                values: [...prevState.values, {id: data.id, fieldName: this.state.selectedField, description: data.description, isActive: data.isActive}], newValue: '', newValueChange: false
            }))
        })
    }

    render() {
        return(
            <div>
                <Alert color="info">
                    <Row>
                        <Col>
                            <h4 className="alert-heading">Edit Dropdown Menus</h4>
                            <p>Select a field to edit.  Values for each field can be modified or inactivated.</p>
                            <p>If a value is modified, records that have that value selected will be modified as well.</p>
                            <p className='mb-0'>Inactivating a value will make it so that no one can choose that value going forward, but does not affect previously entered records.</p>
                        </Col>
                    </Row>
                </Alert>
                <br />
                <Row>
                    <Col sm='3'>
                        <FormGroup>
                            <Label for='fieldPicker'>Select a Field to Edit</Label>
                            <Input name='fieldPicker' id='fieldPicker' type='select' value={this.state.selectedField} onChange={this.onFieldPickerChange} >
                                <option key='blank'></option>
                                {this.state.codeFields.map(option => {
                                    return(
                                        <option key={option} value={option}>{option}</option>
                                    )
                                })}
                            </Input>
                        </FormGroup>
                    </Col>
                </Row>
                
                {this.state.selectedField &&
                    <div>
                        <hr />
                        <Row>
                            <Col sm='2'>
                                <Label for='newValue'>Add a New Value:</Label>
                            </Col>
                            <Col sm='3'>
                                <Input name='newValue' id='newValue' onChange={this.newValueChange} value={this.state.newValue} />
                            </Col>
                            <Col sm='2'>
                                <Button disabled={this.state.addNewDisabled} onClick={this.addNewValue}>Add Value</Button>
                            </Col>
                        </Row>
                    </div>
                }

                {this.state.selectedField && this.state.values.length !== 0 &&
                    <div>
                        <hr />
                        {this.state.values.map((v, i) => {
                            return(
                                <Row className='border rounded' style={{margin:'.5em', padding:'.5em', textAlign:'center', verticalAlign: 'middle'}} key={v.id + v.type}>
                                    <Col sm='5'>
                                        <Input name={i} id={v.id} value={v.description} onChange={this.onValueChange} />
                                    </Col>
                                    <Col sm='2'>
                                        <Label check>
                                            <Input name={i} type='checkbox' checked={v.isActive} onChange={this.onCheckedChange} />
                                            Active
                                        </Label>
                                    </Col>
                                    <Col sm='2'>
                                        <Button name={i} disabled={!v.didChange} onClick={this.handleSave} >Save Change</Button>
                                    </Col>
                                </Row>
                            )
                        })}
                    </div>
                }
            </div>
        )
    }
}